module.exports = __webpack_public_path__ + "static/media/kelly_yu.1e237380.png";